import DateManagementContainer from './DateManagementContainer'

export default function DateManagementScreen() {
    return <DateManagementContainer />
}
